// components
import {
  CSpinner
} from '@coreui/react-pro'

const AppLoader = () => {
  return (
    <div className="loadingAnimationContainer">
      <CSpinner />
      <div className="d-flex" style={{flexDirection: 'column'}}>
        <h1 style={{ color: "black", fontWeight: "600" }}>Loading...</h1>
      </div>
    </div>
  )
}

export default AppLoader